// Runtime config — loaded from /env-config.js (envsubst'd at container start
// from app/web/env-config.template.js using Cloud Run env vars) by index.html
// before the Vite bundle runs. See env-config.template.js for the schema.
//
// All code should read env-driven values via this module, never directly
// from window.__APP_CONFIG__, so:
//   - defaults live in one place
//   - TypeScript catches typos
//   - local dev (where /env-config.js is the stub from public/) still works

type AppConfig = {
  apiUrl: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

export const config: AppConfig = {
  // Falls back to a relative `/api` for local dev (Vite proxy) or when the
  // env var isn't set on the Cloud Run service.
  apiUrl: window.__APP_CONFIG__?.apiUrl || '',
};
